export default __webpack_public_path__ + "static/pulzionTechTreat-526f72d330cc76d488f7f256655771db.png";